import React from 'react'
import './type-pop-up.css'

const TypePopUp = (props) => {
    React.useEffect(() => {
        document.getElementById('the-camera-image').style.opacity = 0
        document.getElementById('type-pop-up-bubble').style.opacity = 1
        document.getElementById('camera-label').style.transform = "scale(1)"
        document.getElementById('mag-glass').style.transform = "scale(1)"
        document.getElementById('play-button').style.transform = "scale(1)"
        document.getElementById('ellipse').style.transform = "scale(1)"
        document.getElementById('dollar').style.transform = "scale(1)"
        document.getElementById('quiz').style.transform = "scale(1)"
        // document.getElementById('recipe').style.transform = "scale(1)"
        document.getElementById('camera-label').style.opacity = "1"
        document.getElementById('mag-glass').style.opacity = "1"
        document.getElementById('play-button').style.opacity = "1"
        document.getElementById('ellipse').style.opacity = "1"
        document.getElementById('dollar').style.opacity = "1"
        document.getElementById('quiz').style.opacity = "1"
        // document.getElementById('recipe').style.opacity = "1"
    }, [])

    return (
        <div className="type-pop-up-bubble" id="type-pop-up-bubble">
            <div className="type-pop-up-icon-wrapper">
                <form onInput={(e) => props.uploadThePhoto(e, props.id)}>
                    <label className="camera" id="camera-label" htmlFor="the-camera-image">
                        <input type="file" name="teacherImage" id="the-camera-image"></input>
                    </label>
                </form>
                {/* <div className="camera" id="camera" onClick={(e) => props.uploadThePhoto(e)}></div> */}
            </div>  
            <div className="type-pop-up-icon-wrapper">
                <div className="mag-glass" id="mag-glass" onClick={() => props.setSectionPhoto(props.id)}></div>
            </div>   
            <div className="type-pop-up-icon-wrapper">
                <div className="play-button" id="play-button" onClick={() => props.setSectionAddVideo(props.id)}></div>
            </div>       
            <div className="type-pop-up-icon-wrapper">
                <div className="ellipse" id="ellipse" onClick={() => props.setSectionEllipse(props.id)}></div>
            </div>
            <div className="type-pop-up-icon-wrapper">
                <div className="dollar" id="dollar" onClick={() => props.setSectionAffiliate(props.id)}></div>
            </div>
            <div className="type-pop-up-icon-wrapper">
                <div className="quiz" id="quiz" onClick={() => props.setSectionQuiz(props.id)}>?</div>
            </div>
            {/* <div className="type-pop-up-icon-wrapper">
                <div className="recipe" id="recipe" onClick={() => props.setSectionRecipeCard(props.id)}></div>
            </div> */}
        </div>
    )
}
export default TypePopUp